module.exports = __webpack_public_path__ + "static/media/grit-leadership-logo-black.434c98c5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/grit-leadership-logo-black.svg
// module id = 7004
// module chunks = 2